'use client';

import { ReactNode, createContext, useContext } from 'react';
import { usePermission } from '@/hooks/usePermission';

interface PermissionContextType {
  can: (config: any) => boolean;
  canView: (config: any) => boolean;
  canEdit: (config: any) => boolean;
  canDelete: (config: any) => boolean;
  canCreate: (config: any) => boolean;
}

const PermissionContext = createContext<PermissionContextType | null>(null);

interface PermissionProviderProps {
  children: ReactNode;
}

export const PermissionProvider = ({ children }: PermissionProviderProps) => {
  const permission = usePermission();

  return (
    <PermissionContext.Provider value={permission}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissionContext = () => {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error('usePermissionContext must be used within PermissionProvider');
  }
  return context;
};